import axios from 'axios'

const updateAccountQuery = async (data: any): Promise<any> =>
  await axios('/api/users/update', { method: 'patch', data })

export { updateAccountQuery }
